<template>
  <div>
    <BaseDrawer>
      <LineList
        :list="list"
        @add="add"
        @moveUp="moveUp"
        @moveDown="moveDown"
        @editItem="editItem"
        @deleteItem="deleteItem"
        v-show="showCom == 'list'"
      ></LineList>
      <EditLine
        @back="showCom = 'list'"
        :editInfo="editInfo"
        v-if="showCom == 'edit'"
      ></EditLine>
    </BaseDrawer>
  </div>
</template>

<script>
import list from '@/utils/configs/LineList.js'
import EditLine from './EditLine.vue'
import LineList from './LineList.vue'
import BaseDrawer from '@/components/common/BaseDrawer.vue'
export default {
  components: {
    BaseDrawer,
    LineList,
    EditLine,
  },
  data() {
    return {
      showCom: 'list',
      editInfo: {}, // 当前编辑的路线
      editIndex: -1,
      list: [],
    }
  },
  methods: {
    //数组元素互换位置
    swapArray(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0]
      return arr
    },
    moveUp(index) {
      if (index == 0 || this.list.length == 1) {
        return
      }
      this.list = this.swapArray(this.list, index - 1, index)
    },
    moveDown(index) {
      if (index == this.list.length - 1) {
        return
      }
      this.list = this.swapArray(this.list, index, index + 1)
    },
    editItem(index) {
      this.showCom = 'edit'
      this.editInfo = this.list[index]
      this.editIndex = index
    },
    deleteItem(index) {
      this.list.splice(index, 1)
    },
    add() {
      this.list.push({
        name: '新线路',
        views: [],
      })
    },
  },

  mounted() {
    this.list = list
  },
}
</script>

<style lang="less" scoped></style>
